import { Injectable } from '@angular/core';
import { IIdentifiable } from '../../src/typings/models';
import { IIdentifiableService } from '../../src/typings/services';

@Injectable({
    providedIn: 'root'
})
export class IdentifiableService implements IIdentifiableService {
    public static $name = 'identifiableService';

    public getIds<T>(items: Array<IIdentifiable<T>>): T[] {
        return items.map((item) => item.id);
    }
}
